import { Component } from "vue-property-decorator"

import DateRangePickerBase from "./dateRangePicker.client.base"

@Component
export default class DateRangePickerWeb extends DateRangePickerBase {}
